// @flow
import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import type {IssuingCategoriesContext} from 'docs/types';
import {Table, TableHeaderCell, TableCell} from '../../core/Table/Table';
import {InlineCode} from '../../core/InlineCode/InlineCode';

type Props = {|
  entries: $PropertyType<IssuingCategoriesContext, 'mcc'>,
|};

const messages = defineMessages({
  code: {
    id: 'docsApp.components.IssuingCategoriesTable.headerCells.code',
    description: 'Category',
    defaultMessage: 'Category',
  },
  description: {
    id: 'docsApp.components.IssuingCategoriesTable.headerCells.description',
    description: 'MCC',
    defaultMessage: 'MCC',
  },
});

export const IssuingCategoriesTable = ({entries}: Props) => {
  return (
    <Table type="striped">
      <thead>
        <tr>
          <TableHeaderCell>
            <FormattedMessage {...messages.code} />
          </TableHeaderCell>
          <TableHeaderCell>
            <FormattedMessage {...messages.description} />
          </TableHeaderCell>
        </tr>
      </thead>
      <tbody>
        {entries.map(([mcc, entry]) => (
          <tr key={mcc}>
            <TableCell>
              {entry.name}
              <br />
              <InlineCode>{entry.code}</InlineCode>
            </TableCell>
            <TableCell>{mcc}</TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
